import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import { useEffect, useMemo, useState, useRef } from 'react'
import {
  fetchData,
  fetchFormData,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../_metronic/i18n/Tr'


const Popup = (props: any) => {
  let t = Tr()

  // add / edit facility states
  const [explorecategoryId, setExplorecategoryId] = useState(props.explorecategoryId)
  const [enName, setEnName] = useState('')
  const [ruName, setRuName] = useState('')
  const [uzName, setUzName] = useState('')

  const [enDescription, setEnDescription] = useState('')
  const [ruDescription, setRuDescription] = useState('')
  const [uzDescription, setUzDescription] = useState('')

  const [error, setError] = useState(Object)
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState('')
  const [addloader, setaddLoader] = useState(false)
  const [disable, setDisable] = useState(false)


  const saveExploreCategory = async () => {
    setDisable(true)

    let param = new FormData()
    param.append('en_name', enName.trim())
    param.append('ru_name', ruName != null ? ruName.trim() : '')
    param.append('uz_name', uzName != null ? uzName.trim() : '')
    param.append('adminId', props.adminId)

    param.append('en_description', enDescription != null ? enDescription.trim() : '')
    param.append('ru_description', ruDescription != null ? ruDescription.trim() : '')
    param.append('uz_description', uzDescription != null ? uzDescription.trim() : '')

    if (image != null && image != undefined) {
      param.append('image', image ? image : '')
    }
    if (props.explorecategoryId != '' && props.explorecategoryId != null && props.explorecategoryId > 0) {
      param.append('explorecategoryId', props.explorecategoryId)
    }

    var response = await fetchFormData('admin/explore/category/save', param)
    if (response.status == '200') {
      const data = response.data
      if (props.explorecategoryId !== '' && props.explorecategoryId !== null && props.explorecategoryId > 0) {
        toastsuccessmsg(response.message)
      } else {
        toastsuccessmsg(response.message)
      }
      
      setDisable(false)
      props.onHide()
    } else {
      setDisable(false)
      toasterrormsg(response.message)
    }
  }
  const validate = () => {
    var errotmp: any = {}
    var err = 0
    if (enName.trim() == '' || enName.trim() == null || enName.trim() == undefined) {
      errotmp['enNameError'] = t('Category  English Name Is Required')
      err = 1
    } else if (enName.trim().length > 50) {
      errotmp['enNameError'] = t('Category English Name Is Too Large')
      err = 1
    } else if (!enName.match(/^[A-Za-z\s&]+$/)) {
      errotmp['enNameError'] = t('Enter Valid Category English Name')
      err = 1
    }

    if (ruName.trim() == '' || ruName.trim() == null || ruName.trim() == undefined) {
      errotmp['ruNameError'] = t('Category Russian Name Is Required')
      err = 1
    } else if (ruName.trim().length > 50) {
      errotmp['ruNameError'] = t('Category Russian Name Is Too Large')
      err = 1
    }
    if (uzName.trim() == '' || uzName.trim() == null || uzName.trim() == undefined) {
      errotmp['uzNameError'] = t('Category Uzbek Name Is Required')
      err = 1
    } else if (uzName.trim().length > 50) {
      errotmp['uzNameError'] = t('Category Uzbek Name Is Too Large')
      err = 1
    }

    if (ruDescription.trim() == '' || ruDescription.trim() == null || ruDescription.trim() == undefined) {
      errotmp['ruDescriptionError'] = t('Category Russian Description Is Required')
      err = 1
    }
    if (enDescription.trim() == '' || enDescription.trim() == null || enDescription.trim() == undefined) {
      errotmp['enDescriptionError'] = t('Category English Description Is Required')
      err = 1
    }
    if (uzDescription.trim() == '' || uzDescription.trim() == null || uzDescription.trim() == undefined) {
      errotmp['uzDescriptionError'] = t('Category Uzbek Description Is Required')
      err = 1
    }

    if (
      (image == null || image == undefined) &&
      (imageUrl == '' || imageUrl == null || imageUrl == undefined)
    ) {
      errotmp['imageError'] = t('Category Image Is Required')
      err = 1
    }
    setError(errotmp)
    if (err == 0) {
      saveExploreCategory()
    }
  }
  const exploreCategoryDetailApiCall = async () => {
    setaddLoader(true)
    var param = {
      explorecategoryId: props.explorecategoryId,
    }
    var response = await fetchData('admin/explore/category/detail', param)

    if (response.status == '200') {
      var data = response.data

      setImageUrl(data.image)

      setEnName(data.en_name)
      setRuName(data.ru_name)
      setUzName(data.uz_name)

      setEnDescription(data.en_description)
      setRuDescription(data.ru_description)
      setUzDescription(data.uz_description)


      setaddLoader(false)
    } else {
      setaddLoader(false)
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    if (props.explorecategoryId > 0) {
      exploreCategoryDetailApiCall()
    }
  }, [])

  // add / edit facility state end
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div className='d-flex align-items-center col-10'>
          <h4 className='fw-bold'>
            {explorecategoryId !== '' && explorecategoryId !== null && explorecategoryId > 0 ? 'Edit' : 'Add'} Explore Category
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
            <div>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6 required'>
                  {t('Image')}
                </label>

                <div className='col-lg-8'>
                  <div className='image-input image-input-outline ' data-kt-image-input='true'>
                    <img
                      alt='images'
                      id='previewImage'
                      className='image-input-wrapper w-125px h-125px changeimg pointer'
                      src={
                        image
                          ? URL.createObjectURL(image)
                          : imageUrl === '' || imageUrl === null
                            ? toAbsoluteUrl('/media/default.jpg')
                            : props.url + imageUrl
                      }
                    />

                    {/* <!--end::Preview existing avatar--> */}
                    {/* <!--begin::Label--> */}
                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      title=''
                      data-bs-original-title='Change avatar'
                    >
                      <i className='fa fa-edit'></i>
                      {/* <!--begin::Inputs--> */}
                      <input
                        type='file'
                        name='image'
                        id='profileImage'
                        accept='.png, .jpg, .jpeg'
                        style={{ display: 'none' }}
                        onChange={(e: any) => {
                          if (
                            e.target.files[0]['type'] != 'image/jpeg' &&
                            e.target.files[0]['type'] != 'image/jpg' &&
                            e.target.files[0]['type'] != 'image/png'
                          ) {
                            alert('Upload Only JPG, PNG Or PNG File')
                          } else if (
                            e.target.files[0] != null &&
                            e.target.files[0] != undefined
                          ) {
                            setImage(e.target.files[0])
                          }
                        }}
                      />
                      <input type='hidden' name='avatar_remove' />
                    </label>
                  </div>

                  <div className='form-text' id='validimage'>
                    {t('Allowed file types: png, jpg, jpeg.')}
                  </div>
                  <label className='text-danger'>{error.imageError || ''}</label>
                </div>
              </div>
            </div>

            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('English Name')}
              </label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('English Name')}
                value={enName}
                onChange={(e: any) => setEnName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.enNameError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Russian Name')}
              </label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Russian Name')}
                value={ruName}
                onChange={(e: any) => setRuName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.ruNameError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Uzbek Name')}
              </label>
              <input
                type='text'
                name='categoryname'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Uzbek Name')}
                value={uzName}
                onChange={(e: any) => setUzName(e.target.value)}
              ></input>
              <label className='text-danger'>{error.uzNameError || ''}</label>
            </div>
            {/* English Description */}
            <div >
              <label className="col-lg-4 col-form-label fw-bold fs-6">
                {t('English Description')}
              </label>
              <textarea
                className="form-control form-control-lg form-control-solid"
                placeholder={t('English Description')}
                value={enDescription}
                onChange={(e: any) => setEnDescription(e.target.value)}
              />
              <label className='text-danger'>{error.enDescriptionError || ''}</label>

            </div>

            {/* Russian Description */}
            <div >
              <label className="col-lg-4 col-form-label fw-bold fs-6">
                {t('Russian Description')}
              </label>
              <textarea
                className="form-control form-control-lg form-control-solid"
                placeholder={t('Russian Description')}
                value={ruDescription}
                onChange={(e: any) => setRuDescription(e.target.value)}
              />
              <label className='text-danger'>{error.ruDescriptionError || ''}</label>

            </div>

            {/* Uzbek Description */}
            <div >
              <label className="col-lg-4 col-form-label fw-bold fs-6">
                {t('Uzbek Description')}
              </label>
              <textarea
                className="form-control form-control-lg form-control-solid"
                placeholder={t('Uzbek Description')}
                value={uzDescription}
                onChange={(e: any) => setUzDescription(e.target.value)}
              />
              <label className='text-danger'>{error.uzDescriptionError || ''}</label>

            </div>

            {/* action button start */}
            <div className={`d-flex pt-15 justify-content-center`}>
              <button
                type='button'
                className={`btn btn-lg btn-light-success me-3`}
                onClick={props.onHide}
              >
                {t('Cancel')}
              </button>

              <button
                type='button'
                disabled={disable}
                className={`btn btn-lg btn-success monthBtn me-3`}
                onClick={() => validate()}
              >
                {!disable && t('Save')}
                {disable && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {t('Please wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* action button end */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}


function ExploreCategories() {
  let t = Tr()
  const { menuIdAdd, menuIdEdit, menuIdDelete } = useMenuIdPermissions()
    let adminId = "";
  const adminData: any = sessionStorage.getItem("admin");

  if (adminData) {
    adminId = JSON.parse(adminData).adminId || "";
  }

  const [showPopup, setShowPopup] = useState(false)
  const [exploreCategoriesList, setExploreCategoriesList] = useState([])
  const [totalRecords, setTotalRecords] = useState<number>()
  const [url, setUrl] = useState("")
  const [explorecategoryId, setExplorecategoryId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Image'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 d-flex align-items-center justify-content-center'>
              <img
                className='w-50px h-50px'
                src={row.image ? url + row.image : toAbsoluteUrl("/media/logos/mainLogo.png")}
                onError={(e) => {
                  e.currentTarget.onerror = null
                  e.currentTarget.src = toAbsoluteUrl('/media/logos/mainLogo.png')
                }}
                alt='images'
              />

            </div>
          </div>
        ),
        sortable: false,
        filter: true,
      },
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit && <button
              className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
              title='Edit'
              onClick={() => {
                setShowPopup(true)
                setExplorecategoryId(row.explorecategoryId)
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>
            }
            {menuIdDelete && <button
              className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
              title='delete'
              onClick={() => deleteExploreCategory(row.explorecategoryId)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  const exploreCategoriesSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

  }

  const deleteExploreCategory = async (explorecategoryId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Explore Category!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            explorecategoryId: String(explorecategoryId),
            adminId : adminId
          }

          const response = await fetchData('admin/explore/category/delete', param , "DELETE")

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            exploreCategoriesListapicall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          // Handle error as needed
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call category list api
  const exploreCategoriesListapicall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
      term: searchTerm,
    }

    var response: any = await fetchData('admin/explore/category/list', param)

    if (response.status == '200') {
      const data = response.data

      setExploreCategoriesList(data.list)
      setTotalRecords(data.totalRecords)
      setUrl(response.url)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Explore Categories'
    exploreCategoriesListapicall()
  }, [limit, offset , searchTerm  ])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Explore Category')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          {menuIdAdd ? (
            <button
              type='button'
              className='btn btn-success monthBtn'
              onClick={() => setShowPopup(true)}
            >
              <KTIcon iconName='plus' className='fs-2' />
              {t('Add Explore Category')}
            </button>
          ) : (
            ''
          )}
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  // pagination functions
  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords! / limit)

    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
{exploreCategoriesList.length > 0 || searchTerm.trim().length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={exploreCategoriesList}
                  pagination
                  paginationServer={true}
                  onChangePage={handlePageChange}
                  paginationTotalRows={totalRecords}
                  paginationPerPage={10}
                  onChangeRowsPerPage={handleRowsPerPageChange}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={exploreCategoriesSearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Explore Categories')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold '>{t('There are no Explore Categories')}</p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Explore Categories')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              setExplorecategoryId(0)
              exploreCategoriesListapicall()

            }}
            // rolelist={roleList}
            explorecategoryId={explorecategoryId}
            url={url}
            adminId={adminId}
          />
        )}
      </div>
    </>
  )
}

export default ExploreCategories
